// dependencies
import PropTypes from "prop-types";
import React from "react";

// styles
import css from "./DownloadButton.module.scss";

/**
 *
 * @param {} size - size of the enclosing square
 * @param {} strokeWidth - size of the enclosing square
 * @param {} percentage - size of the enclosing square
 * @param {} showText - size of the enclosing square
 */
const CircularProgressBar = (props) => {
	const { size = 200, strokeWidth = 2, percentage = 25, showText = false } = props;

	// SVG centers the stroke width on the radius, subtract out so circle fits
	// in square
	const radius = (size - strokeWidth) / 2;
	// Enclose cicle in a circumscribing square
	const viewBox = `0 0 ${size} ${size}`;
	// Arc length at 100% coverage is the circle circumference
	const dashArray = radius * Math.PI * 2;
	// Scale 100% coverage overlay with the actual percent
	const dashOffset = dashArray - (dashArray * percentage) / 100;

	return (
		<svg className={css.radialProgressSvg} width={size} height={size} viewBox={viewBox}>
			<circle
				className={css.circleBackground}
				cx={size / 2}
				cy={size / 2}
				r={radius}
				strokeWidth={`${strokeWidth}px`}
			/>
			<circle
				className={css.circleProgress}
				cx={size / 2}
				cy={size / 2}
				r={radius}
				strokeWidth={`${strokeWidth}px`}
				// Start progress marker at 12 O'Clock
				transform={`rotate(-90 ${size / 2} ${size / 2})`}
				style={{
					strokeDasharray: dashArray,
					strokeDashoffset: dashOffset,
				}}
			/>
			{showText ? (
				<text className="circle-text" x="50%" y="50%" dy=".3em" textAnchor="middle">
					{`${percentage}%`}
				</text>
			) : null}
		</svg>
	);
};

CircularProgressBar.propTypes = {
	showText: PropTypes.bool,
	size: PropTypes.number,
	percentage: PropTypes.number,
	strokeWidth: PropTypes.number,
};

export default CircularProgressBar;
